import React, { useEffect, useState } from "react";
import "./index.css";
import BannerDeslgadoDesktop from "../../assets/images/pngs/banner_deslogado.png";
import BannerDeslgadoMobile from "../../assets/images/pngs/banner_deslogado.png";
import { slide as MenuBurger } from "react-burger-menu";
import ImgAmigoLeo from "../../assets/images/pngs/logoTelas.png";
import FaqDeslogado from "../FaqDeslogado";
import FaleConoscoDeslogado from "../FaleConoscoDeslogado";
import FooterDeslogado from "../FooterDeslogado";
import storage from "../../services/storage";
import BarraPolitica from "../Politica/BarraPolitica";
import { Modal, Typography } from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import ApiServices from "../../services/apiServices";
import cookie from "react-cookies";
import Regulamento from "../Regulamento";
import { IoMenuSharp, IoClose } from "react-icons/io5";
export default function HomeDeslogado() {
  const [tipoMenu, setTipoMenu] = useState("programa");
  const [tipoModal, setTipoModal] = useState(0);
  const [menuAberto, setMenuAberto] = useState(false);

  var token = cookie.load("token");

  // MARCELLO SPIRONELLI
  // MARCELLO SPIRONELLI
  // MARCELLO SPIRONELLI
  // token =
  //   "jsnnapkwhMw8clFUYWN/rzbKB/N8P/lu4Phd3KaSIWAKbDfw3rHpCeUt2lAHtuCrJqgax3lu7RIFnO3md6wL9vlR0Al2QePvovMEj80CKx57wuG2r7RRXYhkANbSondJj6SIBCX1nsZqZzyUIV+SG3r5pozOWfl4WUeToj6QuLm9mr157oY2rWRaSSVkhcVfHrCSk8b0vkmCqtbr3UFPvlp8tXalATkoG5HcVo0jo4VuoaHEcriVaWWjsheFuCc5wRlQ3jmif1Fj3n03LB0aFg0a7r9i97V7hQ2wGSPfk3WaBE2n5617BTsssbKiy7lGtokB+jf9EMS3w2Pivmzv7pW3+SJmj/HqCxcsJKrz/BcAOEim9psYy2no9HbByVh5IzFMUTFQa+RSslUJ3WQMq8lhjs1u9n/qNhw89cM1nf0gPDQkhgVNwwpHl8xK2yILssBq10HqdcSrc8OEvVg3tg==";

  async function usuarioExterno() {
    if (typeof token === "string" && token.trim() !== "") {
      try {
        let response = await ApiServices.apiLoginBase("login/external", token);

        if (response.statusCode === 200) {
          if (response.data.isAmigoLeo === false) {
            setTipoModal(1);
            storage.set("TIPOMODAL", 1);
          } else {
            storage.set("TIPOMODAL", 0);
          }
        } else {
          if (response.data.isAmigoLeo === true) {
            setTipoModal(2);
          } else {
            setTipoModal(1);
          }
        }
      } catch (err) {
        console.error("err", err);
      } finally {
      }
    }
  }

  useEffect(() => {
    usuarioExterno();
  }, []);

  return (
    <>
      <div className="mobileDeslogado menuMobileCenter mobileDeslogadoFundo">
        <img
          src={ImgAmigoLeo}
          alt="logo amigo leo"
          style={{
            height: "auto",
            width: "auto",
            maxHeight: "80px",
            maxWidth: "10%",
            margin: "20px ",
            
          }}
        />
        {/* Botão do menu customizado */}
        <button
          className={`mobile-menu-button-deslogado ${menuAberto ? "menu-aberto" : ""}`}
          onClick={() => setMenuAberto(!menuAberto)}
          aria-label="Menu"
        >
          {menuAberto ? (
            <IoClose size={32} color="#fff" />
          ) : (
            <IoMenuSharp size={50} color="#fff" />
          )}
        </button>
        <MenuBurger 
          right 
          className="menuHomeDeslogado"
          isOpen={menuAberto}
          onStateChange={(state) => setMenuAberto(state.isOpen)}
          customBurgerIcon={false}
        >
          <div className="my-5 px-5">
            <span
              className="btn btn-warning"
              onClick={() =>
                (window.location.href =
                  "https://www.leomadeiras.com.br/?amigoleo=1")
              }
            >
              ENTRAR
            </span>
          </div>
          <span className="d-flex flex-column align-items-center">
            <span
              onClick={() => {
                setTipoMenu("programa");
                setMenuAberto(false);
              }}
              className={
                "btn-menu-deslogado my-2 " +
                (tipoMenu === "programa" ? "btn-ativado-deslogado" : "")
              }
            >
              <span>O PROGRAMA</span>
            </span>
            <span
              // onClick={() => {
              //   setTipoMenu("fale-conosco");
              // }}
              onClick={() => {
                window.open(
                  "https://api.whatsapp.com/send/?phone=5508005910127",
                  "_blank",
                  "noopener,noreferrer"
                );
                setMenuAberto(false);
              }}
              className={
                "btn-menu-deslogado my-2 " +
                (tipoMenu === "fale-conosco" ? "btn-ativado-deslogado" : "")
              }
            >
              <span>FALE CONOSCO</span>
            </span>
            <span
              onClick={() => {
                setTipoMenu("regulamento");
                setMenuAberto(false);
              }}
              className={
                "btn-menu-deslogado my-2 " +
                (tipoMenu === "regulamento" ? "btn-ativado-deslogado" : "")
              }
            >
              <span>REGULAMENTO</span>
            </span>
            <span
              onClick={() => {
                setTipoMenu("faq");
                setMenuAberto(false);
              }}
              className={
                "btn-menu-deslogado my-2 " +
                (tipoMenu === "faq" ? "btn-ativado-deslogado" : "")
              }
            >
              <span>FAQ</span>
            </span>
          </span>
        </MenuBurger>
      </div>

      <div className="desktopDeslogado desktopDeslogadoFundo d-flex justify-content-around py-3">
      <img
          src={ImgAmigoLeo}
          alt="logo amigo leo"
          style={{
            height: "auto",
            width: "auto",
            maxHeight: "80px",
            maxWidth: "100%",
          }}
        />

        <span className="d-flex align-items-center">
          <span
            onClick={() => {
              setTipoMenu("programa");
            }}
            className={
              "btn-menu-deslogado my-2 " +
              (tipoMenu === "programa" ? "btn-ativado" : "")
            }
          >
            <span>O PROGRAMA</span>
          </span>
          <span
            // onClick={() => {
            //   setTipoMenu("fale-conosco");
            // }}
            onClick={() => {
              window.open(
                "https://api.whatsapp.com/send/?phone=5508005910127",
                "_blank",
                "noopener,noreferrer"
              );
            }}
            className={
              "btn-menu-deslogado my-2 " +
              (tipoMenu === "fale-conosco" ? "btn-ativado" : "")
            }
          >
            <span>FALE CONOSCO</span>
          </span>
          <span
            onClick={() => {
              setTipoMenu("regulamento");
            }}
            className={
              "btn-menu-deslogado my-2 " +
              (tipoMenu === "regulamento" ? "btn-ativado" : "")
            }
          >
            <span>REGULAMENTO</span>
          </span>
          <span
            onClick={() => {
              setTipoMenu("faq");
            }}
            className={
              "btn-menu-deslogado my-2 " +
              (tipoMenu === "faq" ? "btn-ativado" : "")
            }
          >
            <span>FAQ</span>
          </span>
          <span style={{ marginLeft: 100 }}>
            <button
              style={{ maxWidth: 100, maxHeight: 35, display:"flex",   alignItems: "center",
                justifyContent: "center",}}
              className="btn btn-warning"
              onClick={() =>
                (window.location.href =
                  "https://www.leomadeiras.com.br/?amigoleo=1")
              }
            >
              ENTRAR
            </button>
          </span>
        </span>
      </div>

      {tipoMenu === "programa" && (
        <div className="d-flex justify-content-center ">
          <div className="container  ">
            <img
              className="desktopDeslogado"
              width={"100%"}
              src={BannerDeslgadoDesktop}
              alt="Banner Desktop"
            />
            <img
              className="mobileDeslogado"
              width={"100%"}
              src={BannerDeslgadoMobile}
              alt="Banner Mobile"
            />
          </div>
        </div>
      )}
      {tipoMenu === "fale-conosco" && <FaleConoscoDeslogado />}
      {tipoMenu === "regulamento" && <Regulamento />}
      {tipoMenu === "faq" && <FaqDeslogado />}
      {/* <BarraPolitica/> */}
      {storage.get("POLITICA") !== "true" && storage.get("TOKEN") !== null && (
        <BarraPolitica />
      )}
      <FooterDeslogado />

      <Modal
        keepMounted
        open={tipoModal != 0}
        onClose={() => setTipoModal(0)}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <>
          {tipoModal == 1 && (
            <Box className="configModal">
              <div
                className="d-flex justify-content-end pointer"
                style={{ marginTop: -25, marginRight: -25 }}
              >
                <CloseIcon onClick={() => setTipoModal(0)} />
              </div>

              <Typography
                id="keep-mounted-modal-title"
                variant="h6"
                component="h2"
                className="text-center"
              >
                Para acessar o programa <strong>AMIGO LEO</strong>, você precisa
                <br />
                falar com seu vendedor e atualizar seu cadastro.
                <br />
                <br />
                <strong>Estamos te esperando!</strong>
              </Typography>
            </Box>
          )}
          {tipoModal == 2 && (
            <Box className="configModal">
              <div
                className="d-flex justify-content-end pointer"
                style={{ marginTop: -25, marginRight: -25 }}
              >
                <CloseIcon onClick={() => setTipoModal(0)} />
              </div>

              <Typography
                id="keep-mounted-modal-title"
                variant="h6"
                component="h2"
                className="text-center"
              >
                Para acessar o programa<strong> AMIGO LEO</strong>, você precisa
                <br />
                entrar em contato com a nossa Central de Atendimento
                <br />
                no telefone 0800 591 0127
                <br />
                <br />
                <strong>Estamos te esperando!</strong>&nbsp;
              </Typography>
            </Box>
          )}
        </>
      </Modal>
    </>
  );
}
